module.exports = __webpack_public_path__ + "img/green_number.a0d7da00.png";